import { render } from "./RegistrationHeader.vue?vue&type=template&id=723d0030&scoped=true&ts=true"
import script from "./RegistrationHeader.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationHeader.ts?vue&type=script&lang=ts&external"

import "./RegistrationHeader.scss?vue&type=style&index=0&id=723d0030&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723d0030"]])

export default __exports__